module.exports = __webpack_public_path__ + "img/Datadownload.6afa5a0e.png";